// src/utils/reporteModulosGenerator.js

// 👈 NUEVO: Importar función que obtiene los datos de la empresa actual
import { obtenerDatosEmpresa } from './tenantConfig';

// Configuración por defecto (fallback)
const SYSTEM_JJ_CONFIG = {
  nombre: 'SYSTEM JJ',
  rif: 'J-41023119-0',
  slogan: 'Soluciones Tecnológicas',
  direccion: 'CALLE 30, CON AV. 33, C.C LATIN CENTER, LOCAL 01',
  ciudad: 'ACARIGUA, EDO. PORTUGUESA',
  telefono: '04145146450 / 5516151 / 02556223297',
  email: 'SOPORTE@SYSTEMJJ.COM',
  sitioWeb: 'www.systemjj.com'
};

/**
 * 👈 NUEVO: Obtiene la config de la empresa actual con fallback
 */
const getEmpresa = () => {
  try {
    const datos = obtenerDatosEmpresa();
    return {
      nombre: datos.nombreComercial || datos.nombre || SYSTEM_JJ_CONFIG.nombre,
      rif: datos.rif || SYSTEM_JJ_CONFIG.rif,
      slogan: datos.slogan || SYSTEM_JJ_CONFIG.slogan,
      direccion: datos.direccion || SYSTEM_JJ_CONFIG.direccion,
      ciudad: datos.ciudad || SYSTEM_JJ_CONFIG.ciudad,
      telefono: datos.telefono1 || datos.telefono2 || SYSTEM_JJ_CONFIG.telefono,
      email: datos.email || SYSTEM_JJ_CONFIG.email,
      sitioWeb: datos.sitioWeb || SYSTEM_JJ_CONFIG.sitioWeb,
      logoBase64: datos.logoBase64 || null,
    };
  } catch (err) {
    console.warn('⚠️ No se pudo obtener config del tenant, usando fallback:', err);
    return { ...SYSTEM_JJ_CONFIG, logoBase64: null };
  }
};

/**
 * Imprimir reporte completo de módulos
 * @param {Array} modulos - Lista de módulos
 * @param {string} titulo - Título del reporte
 * @param {Object} filtros - Filtros aplicados
 */
export const imprimirReporteModulos = (modulos, titulo, filtros = {}) => {
  const ventana = window.open('', '_blank');
  if (!ventana) {
    alert('Por favor, permite las ventanas emergentes para imprimir');
    return;
  }
  
  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant
  const fechaActual = new Date().toLocaleString('es-ES');
  const totalActivos = modulos.filter(m => m.estado?.toLowerCase() === 'activo').length;
  const totalInactivos = modulos.filter(m => m.estado?.toLowerCase() === 'inactivo').length;
  
  ventana.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${titulo} - ${empresa.nombre}</title>
      <meta charset="UTF-8">
      <style>
        body {
          font-family: 'Segoe UI', Arial, sans-serif;
          margin: 40px;
          color: #333;
        }
        .empresa-header {
          display: flex;
          align-items: center;
          gap: 15px;
          padding-bottom: 15px;
          margin-bottom: 20px;
          border-bottom: 3px solid #4f46e5;
        }
        .logo-img {
          height: 60px;
          width: auto;
          object-fit: contain;
        }
        .empresa-info h2 {
          margin: 0;
          color: #4f46e5;
          font-size: 18px;
        }
        .empresa-info p {
          margin: 2px 0;
          font-size: 11px;
          color: #666;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          padding-bottom: 20px;
        }
        .title {
          font-size: 24px;
          font-weight: bold;
          color: #4f46e5;
        }
        .subtitle {
          color: #666;
          margin-top: 10px;
        }
        .stats {
          display: flex;
          justify-content: space-between;
          margin: 20px 0;
          padding: 15px;
          background: #f3f4f6;
          border-radius: 8px;
        }
        .stat-card {
          text-align: center;
        }
        .stat-number {
          font-size: 24px;
          font-weight: bold;
          color: #4f46e5;
        }
        .stat-label {
          font-size: 12px;
          color: #666;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 10px;
          text-align: left;
        }
        th {
          background-color: #4f46e5;
          color: white;
        }
        tr:nth-child(even) {
          background-color: #f9fafb;
        }
        .footer {
          margin-top: 30px;
          text-align: center;
          font-size: 12px;
          color: #666;
          border-top: 1px solid #ddd;
          padding-top: 20px;
        }
        .badge {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
        }
        .badge-active {
          background: #10b981;
          color: white;
        }
        .badge-inactive {
          background: #ef4444;
          color: white;
        }
        @media print {
          body {
            margin: 0;
            padding: 20px;
          }
          .no-print {
            display: none;
          }
        }
      </style>
    </head>
    <body>
      <!-- HEADER DE EMPRESA -->
      <div class="empresa-header">
        ${empresa.logoBase64 ? `<img src="${empresa.logoBase64}" class="logo-img" onerror="this.style.display='none'">` : ''}
        <div class="empresa-info">
          <h2>${empresa.nombre}</h2>
          <p>RIF: ${empresa.rif} | ${empresa.direccion}</p>
          <p>${empresa.ciudad} | Tel: ${empresa.telefono}</p>
        </div>
      </div>

      <div class="header">
        <div class="title">${titulo}</div>
        <div class="subtitle">Fecha de generación: ${fechaActual}</div>
        ${filtros.busqueda ? `<div class="subtitle">Búsqueda: "${filtros.busqueda}"</div>` : ''}
        ${filtros.estado !== 'all' ? `<div class="subtitle">Estado: ${filtros.estado === 'activos' ? 'Activos' : 'Inactivos'}</div>` : ''}
      </div>
      
      <div class="stats">
        <div class="stat-card">
          <div class="stat-number">${modulos.length}</div>
          <div class="stat-label">Total Módulos</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">${totalActivos}</div>
          <div class="stat-label">Activos</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">${totalInactivos}</div>
          <div class="stat-label">Inactivos</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">${modulos.filter(m => m.descripcion).length}</div>
          <div class="stat-label">Con Descripción</div>
        </div>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Módulo</th>
            <th>Ruta</th>
            <th>Icono</th>
            <th>Estado</th>
            <th>Fecha Creación</th>
          </tr>
        </thead>
        <tbody>
          ${modulos.map(modulo => `
            <tr>
              <td>${modulo.idModulo}</td>
              <td>
                <strong>${modulo.nombre}</strong><br>
                <small>${modulo.descripcion || 'Sin descripción'}</small>
              </td>
              <td><code>${modulo.ruta || '/'}</code></td>
              <td>${modulo.icono || 'mdi:folder-outline'}</td>
              <td>
                <span class="badge ${modulo.estado?.toLowerCase() === 'activo' ? 'badge-active' : 'badge-inactive'}">
                  ${modulo.estado || 'Sin estado'}
                </span>
              </td>
              <td>${new Date(modulo.fecha_creacion || modulo.fechaCreacion).toLocaleDateString('es-ES')}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <div class="footer">
        <p>${empresa.nombre} - Reporte generado automáticamente por el sistema</p>
        <p>${empresa.sitioWeb} | ${empresa.email}</p>
        <p>© ${new Date().getFullYear()} - Todos los derechos reservados</p>
      </div>
    </body>
    </html>
  `);
  
  ventana.document.close();
  ventana.print();
};

/**
 * Imprimir reporte simplificado de módulos
 * @param {Array} modulos - Lista de módulos
 * @param {string} titulo - Título del reporte
 */
export const imprimirReporteSimplificado = (modulos, titulo) => {
  const ventana = window.open('', '_blank');
  if (!ventana) {
    alert('Por favor, permite las ventanas emergentes para imprimir');
    return;
  }
  
  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant
  const fechaActual = new Date().toLocaleString('es-ES');
  
  ventana.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${titulo} - ${empresa.nombre}</title>
      <meta charset="UTF-8">
      <style>
        body {
          font-family: 'Segoe UI', Arial, sans-serif;
          margin: 40px;
          color: #333;
        }
        .empresa-header {
          display: flex;
          align-items: center;
          gap: 15px;
          padding-bottom: 15px;
          margin-bottom: 20px;
          border-bottom: 3px solid #4f46e5;
        }
        .logo-img {
          height: 50px;
          width: auto;
          object-fit: contain;
        }
        .empresa-info h2 {
          margin: 0;
          color: #4f46e5;
          font-size: 16px;
        }
        .empresa-info p {
          margin: 2px 0;
          font-size: 10px;
          color: #666;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          padding-bottom: 20px;
        }
        .title {
          font-size: 24px;
          font-weight: bold;
          color: #4f46e5;
        }
        .subtitle {
          color: #666;
          margin-top: 10px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #4f46e5;
          color: white;
        }
        .footer {
          margin-top: 30px;
          text-align: center;
          font-size: 12px;
          color: #666;
        }
        .badge {
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 11px;
        }
        .badge-active {
          background: #10b981;
          color: white;
        }
        .badge-inactive {
          background: #ef4444;
          color: white;
        }
      </style>
    </head>
    <body>
      <!-- HEADER DE EMPRESA -->
      <div class="empresa-header">
        ${empresa.logoBase64 ? `<img src="${empresa.logoBase64}" class="logo-img" onerror="this.style.display='none'">` : ''}
        <div class="empresa-info">
          <h2>${empresa.nombre}</h2>
          <p>RIF: ${empresa.rif} | ${empresa.ciudad}</p>
        </div>
      </div>

      <div class="header">
        <div class="title">${titulo}</div>
        <div class="subtitle">Fecha: ${fechaActual}</div>
        <div class="subtitle">Total: ${modulos.length} módulos</div>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>Módulo</th>
            <th>Ruta</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          ${modulos.map(modulo => `
            <tr>
              <td>${modulo.nombre}</td>
              <td><code>${modulo.ruta || '/'}</code></td>
              <td>
                <span class="badge ${modulo.estado?.toLowerCase() === 'activo' ? 'badge-active' : 'badge-inactive'}">
                  ${modulo.estado || 'Sin estado'}
                </span>
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <div class="footer">
        <p>${empresa.nombre} - Documento generado automáticamente</p>
      </div>
    </body>
    </html>
  `);
  
  ventana.document.close();
  ventana.print();
};

export default {
  imprimirReporteModulos,
  imprimirReporteSimplificado
};